.wishlistPrivacy {
  display: flex;
  margin: -1.25rem;
  padding: 1.25rem;
  overflow: auto;
  gap: 0.75rem;
  scrollbar-width: none;

  @media (min-width: 769px) {
    margin: 0;
    padding: 0;
    overflow: visible;
  }

  .privacyOption {
    display: flex;
    position: relative;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    height: 100%;
    padding: 0.75rem 0.875rem;
    border-radius: 1rem;
    line-height: 150%;

    &.privacyOptionActive {
      background-color: rgba(var(--primary-600-rgb), 0.1);
    }

    .privacyOptionIcon {
      margin: 0 0 0.125rem;

      svg {
        width: 1.25rem;
        height: 1.25rem;
        stroke-width: 1.5;
      }
    }

    .privacyOptionLabel {
      margin: 0 0 0.0625rem;
    }

    .privacyOptionDescription {
      opacity: 0.75;
      padding: 0 0.375rem 0 0;
    }

    .privacyOptionCheck {
      position: absolute;
      top: 0.625rem;
      right: 0.625rem;

      svg {
        width: 1.5rem;
        height: 1.5rem;
      }
    }
  }
}
